import { useQuery } from '@tanstack/react-query';
import { alloysApi, containersApi, driversApi, materialsApi, plantsApi } from '../api/masterdata';

const STALE_TIME = 5 * 60_000;

/** Stammdaten ändern sich selten - ein gemeinsamer, lang gecachter Hook für alle Formulare/Filter, die sie brauchen. */
export function useMasterData() {
  const plants = useQuery({ queryKey: ['plants'], queryFn: plantsApi.list, staleTime: STALE_TIME });
  const containers = useQuery({ queryKey: ['containers'], queryFn: containersApi.list, staleTime: STALE_TIME });
  const materials = useQuery({ queryKey: ['materials'], queryFn: materialsApi.list, staleTime: STALE_TIME });
  const alloys = useQuery({ queryKey: ['alloys'], queryFn: alloysApi.list, staleTime: STALE_TIME });
  const drivers = useQuery({ queryKey: ['drivers'], queryFn: driversApi.list, staleTime: STALE_TIME });

  return {
    plants,
    containers,
    materials,
    alloys,
    drivers,
    isLoading: [plants, containers, materials, alloys, drivers].some((q) => q.isLoading),
  };
}
